/**
 * Rocksoft In-Room Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BaseDataResultApiModelOfIEnumerableOfMoodsResultApiModel } from '../model/baseDataResultApiModelOfIEnumerableOfMoodsResultApiModel';
// @ts-ignore
import { BaseResultApiModel } from '../model/baseResultApiModel';
// @ts-ignore
import { MoodsRequestApiModel } from '../model/moodsRequestApiModel';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface GetAllMoodsRequestParams {
    hotelCode: string;
    room: string;
}

export interface StartMoodRequestParams {
    hotelCode: string;
    room: string;
    moodsRequestApiModel?: MoodsRequestApiModel;
}


@Injectable({
  providedIn: 'root'
})
export class MoodsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /{hotelCode}/ctrlapi/1/{room}/moods/list
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getAllMoods(requestParameters: GetAllMoodsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseDataResultApiModelOfIEnumerableOfMoodsResultApiModel>;
    public getAllMoods(requestParameters: GetAllMoodsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseDataResultApiModelOfIEnumerableOfMoodsResultApiModel>>;
    public getAllMoods(requestParameters: GetAllMoodsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseDataResultApiModelOfIEnumerableOfMoodsResultApiModel>>;
    public getAllMoods(requestParameters: GetAllMoodsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling getAllMoods.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling getAllMoods.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/moods/list`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseDataResultApiModelOfIEnumerableOfMoodsResultApiModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /{hotelCode}/ctrlapi/1/{room}/moods/start
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public startMood(requestParameters: StartMoodRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<BaseResultApiModel>;
    public startMood(requestParameters: StartMoodRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BaseResultApiModel>>;
    public startMood(requestParameters: StartMoodRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BaseResultApiModel>>;
    public startMood(requestParameters: StartMoodRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const hotelCode = requestParameters?.hotelCode;
        if (hotelCode === null || hotelCode === undefined) {
            throw new Error('Required parameter hotelCode was null or undefined when calling startMood.');
        }
        const room = requestParameters?.room;
        if (room === null || room === undefined) {
            throw new Error('Required parameter room was null or undefined when calling startMood.');
        }
        const moodsRequestApiModel = requestParameters?.moodsRequestApiModel;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (basic) required
        localVarHeaders = this.configuration.addCredentialToHeaders('basic', 'Authorization', localVarHeaders, 'Basic ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/${this.configuration.encodeParam({name: "hotelCode", value: hotelCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ctrlapi/1/${this.configuration.encodeParam({name: "room", value: room, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/moods/start`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BaseResultApiModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: moodsRequestApiModel,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
